
				var addMethods = require("../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["obfuscateCode","applyTransformations","preObfuscationAnalysis"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "bc3123263ef7ae8d4e39.worker.js", { name: "[fullhash].worker.js" })
					URL.revokeObjectURL(__webpack_public_path__ + "bc3123263ef7ae8d4e39.worker.js");
					addMethods(w, methods)
					
					return w
				}
			